import config from '../config';

export interface EmailSequenceRequest {
    industry: string;
    target_role: string;
    tone_of_voice: string;
    value_proposition: string;
    num_emails?: number;
    additional_context?: string;
}

export interface EmailSequenceResponse {
    research: string;
    sequence: string[];
}

export async function generateColdEmailSequence(request: EmailSequenceRequest): Promise<EmailSequenceResponse> {
    try {
        console.log('Generating cold email sequence with config:', {
            apiUrl: config.apiUrl,
            request
        });

        const response = await fetch(config.getFullUrl('/generate-sequence'), {
            method: 'POST',
            ...config.fetchOptions,
            body: JSON.stringify(request)
        });

        if (!response.ok) {
            console.error('API Error Response:', {
                status: response.status,
                statusText: response.statusText,
                headers: Object.fromEntries(response.headers.entries())
            });
            
            const errorText = await response.text();
            console.error('Error Response Body:', errorText);
            
            throw new Error(`API request failed: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        console.log('API Response:', data);
        
        return data;
    } catch (error) {
        console.error('Error generating cold email sequence:', error);
        throw error;
    }
} 